// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'amfe-flexible'
Vue.config.productionTip = false
import 'swiper/dist/css/swiper.css'
import VueAwesomeSwiper, {
  swiper,
  swiperSlide
} from 'vue-awesome-swiper'
Vue.component(swiper)
Vue.component(swiperSlide)
Vue.use(VueAwesomeSwiper)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js